import { render, staticRenderFns } from "./Subtrabajo.vue?vue&type=template&id=4d351c9c&"
import script from "./Subtrabajo.vue?vue&type=script&lang=js&"
export * from "./Subtrabajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports